import React, { useState } from "react";

import RtpTable from "./RtpTable";
import RtpTable2 from "./RtpTable2";

export const TableCombined = () => {
  const [showPercentage, setShowPercentage] = useState(false);

  const handleToggle = () => {
    setShowPercentage((prev) => !prev);
  };

  return (
    <div className=" p-2 bg-white rounded-md">
      <div className="flex justify-end px-2">
        <span className="mr-2 text-gray-700 md:text-sm text-[11px]">
          {showPercentage ? "Show Values" : "Show Percentage"}
        </span>
        <label className="relative inline-block w-10 align-middle select-none">
          <input
            type="checkbox"
            checked={showPercentage}
            onChange={handleToggle}
            className="toggle-checkbox absolute block w-6 h-6 rounded-full appearance-none cursor-pointer border-2 border-transparent transition-transform duration-200"
          />
          <span
            className={`toggle-label block overflow-hidden h-6 rounded-full cursor-pointer ${
              showPercentage ? "bg-[#AAE0D3]" : "bg-[#b9b8f4]"
            }`}
          >
            <span
              className={`block h-5 w-5 rounded-full ${
                showPercentage ? "bg-[#599f8e]" : "bg-[#8381fe]"
              } shadow-md transform transition-transform duration-200 ${
                showPercentage ? "translate-x-full" : "translate-x-0"
              } translate-y-0.5`}
            ></span>
          </span>
        </label>
      </div>
      <div>{showPercentage ? <RtpTable2 /> : <RtpTable />}</div>
    </div>
  );
};
